import { getPhantomPaths, getSubwayPaths } from '../api'

const initialState = {
    isLoading: true,
    phantomLines: { routes: [] },
    subwayLines: { routes: [] }
}

export const lines = ({
    state: initialState,
    reducers: {
        setPhantomPaths(state, lines) {
            return {
                ...state,
                phantomLines: { routes: lines },
                isLoading: false
            }
        },
        setSubwayPaths(state, lines) {
            return {
                ...state,
                subwayLines: { routes: lines },
                isLoading: false
            }
        }
    },
    effects: {
        async loadPhantomPaths() {
            const lines = await getPhantomPaths()
            this.setPhantomPaths(lines)
        },
        async loadSubwayPaths() {
            const lines = await getSubwayPaths()
            this.setSubwayPaths(lines)
        }
    }
})
